import React from 'react';
import {useSelector} from 'react-redux';
import {Helmet} from 'react-helmet-async';
import {Box, Heading, Text, Container} from '@spothero/ui';

import Image from 'common/image';
import useConfig from 'hooks/use-config';

const ERRORS = {
    default: 'default',
    unauthorized: 'unauthorized',
    'control-panel': 'control-panel',
    'tow-truck': 'tow-truck',
    'access-denied': 'access_denied',
};

const sharedErrorText =
    "It looks like you don't have permission to view this page, or your access may be restricted. If you believe this is in error, please contact ";

const ERROR_DETAILS = {
    [ERRORS.default]: {
        img: 'img/car-flat-tire.svg',
        title: 'Something went wrong',
        description: () => (
            <>
                It looks like an error occurred. Sorry about that! Please reach
                out to{' '}
                <a href="mailto:support@spothero.com">support@spothero.com</a>{' '}
                for support. They may be able to help.
            </>
        ),
    },
    [ERRORS.unauthorized]: {
        img: 'img/road-closed.svg',
        title: "You don't have access to this page",
        description: () => (
            <>
                {sharedErrorText}
                <a href="mailto:support@spothero.com">support@spothero.com</a>.
            </>
        ),
    },
    [ERRORS['access-denied']]: {
        img: 'img/road-closed.svg',
        title: "You don't have access to this page",
        description: () => (
            <>
                {sharedErrorText}
                <a href="mailto:support@spothero.com">support@spothero.com</a>.
            </>
        ),
    },
    [ERRORS['control-panel']]: {
        img: 'img/road-closed.svg',
        title: "You don't have access to this page",
        description: () => (
            <>
                {sharedErrorText}
                <a href="mailto:sellersupport@spothero.com">
                    sellersupport@spothero.com
                </a>
                .
            </>
        ),
    },
    [ERRORS['tow-truck']]: {
        img: 'img/road-closed.svg',
        title: "You don't have access to this page",
        description: () => (
            <>
                {sharedErrorText}
                <a href="mailto:integrations-support@spothero.com">
                    integrations-support@spothero.com
                </a>
                .
            </>
        ),
    },
};

const AuthError = () => {
    const {staticBaseUrl} = useConfig();
    const {error} = useSelector(state => state.page);
    const errorObj =
        ERROR_DETAILS[ERRORS[error]] || ERROR_DETAILS[ERRORS.default];

    return (
        <Box className="ErrorPage">
            <Helmet>
                <title>{errorObj.title}</title>
                <body className="error-page" />
            </Helmet>
            <Container textAlign="center" py="3rem">
                <Box>
                    <Image
                        width="6.5rem"
                        height="6.5rem"
                        src={`${staticBaseUrl}${errorObj.img}`}
                        showLoader={false}
                    />
                    <Heading as="h1" my="1rem">
                        Uh Oh!
                    </Heading>
                    <Heading>{errorObj.title}</Heading>
                    <Text maxWidth="37rem" margin="1rem auto 0">
                        {errorObj.description()}
                    </Text>
                </Box>
            </Container>
        </Box>
    );
};

export default AuthError;
